import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  ChangeDetectorRef,
  inject
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'bepatient-my-account-button',
  templateUrl: './my-account-button.component.html',
  styleUrls: ['./my-account-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MyAccountButtonComponent implements OnDestroy {
  private cdr = inject(ChangeDetectorRef);
  private themeService = inject(ThemeService);

  @Input() icon: string;
  @Output() buttonClicked = new EventEmitter();
  themeColor: string = 'light';
  private themeSubscription: Subscription;

  constructor() {
    // Subscribe to theme changes
    this.themeColor = this.themeService.getCurrentThemeColor();
    this.themeSubscription = this.themeService
      .getThemeColor()
      .subscribe(themeColor => {
        this.themeColor = themeColor;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  onButtonClicked(): void {
    this.buttonClicked.emit(true);
  }
}
